/*
 * @Author: cc
 * @Date: 2021-12-10 14:28:57
 * @LastEditTime: 2021-12-10 14:39:31
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoResource\custom\customRouter.js
 * @Description: 
 */
/* create by ma.rongqin 2016.3.6*/
'use strict';
angular.module('editIWoResourceCustomRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.iWo.custom', {
            url: '/custom?customid&customtype&mycustomid&isugc',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/iWoResource/custom/custom_tpl.html',
                    controller: 'editIWoResourceCustomCtrl'
                }
            }
        }).state('front.editctr.iWo.emaildraft', {
            url: '/emaildraft?customid&customtype&mycustomid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/iWoResource/custom/emailDraft_tpl.html',
                    controller: 'editingCenterSharedMailCtrl'
                }
            }
        }).state('front.editctr.iWo.customforugc', {
            url: '/customforugc?customid&customtype&mycustomid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/iWoResource/custom/customForUgc/customForUgc_tpl.html',
                    controller: 'customForUgcCtrl'
                }
            }
        });
    }]);
